import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Travel } from 'app/models/travel.model';
import { environment } from 'environments/environment';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AngularFirestore } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class TravelService {
  private apiUrl: string = `${environment.apiUrl}travel`;
  constructor(private httpClient: HttpClient, private firestore: AngularFirestore) { }

  public async getTravels(domainId: number){
    console.log('consultando viajes por dominio ' + domainId);
    return await this.httpClient.get<Travel[]>(`${this.apiUrl}/byDomain/${domainId}`).toPromise();
  }

  public saveTravel(travel: Travel){
    console.log('saving travel...');
    try {
      if(travel.id){
        console.log('updating travel');
        return this.httpClient.put<Travel>(this.apiUrl, travel).pipe(
          catchError(this.handleError)
        );
      }else{
        console.log('creating new travel');
        return this.httpClient.post<Travel>(this.apiUrl, travel).pipe(
          catchError(this.handleError)
        );
      }
    } catch (error) {
      console.error('error on save travel', error);
    }
  }

  public getTravelsByDomain(domainId: number){
    console.log('consultando viajes por dominio ' + domainId);
    return this.httpClient.get<Travel[]>(`${this.apiUrl}/byDomain/${domainId}`);
  }

  public async getTravelsByEnterprise(enterpriseId: number){
    console.log('consultando viajes por la empresa ' + enterpriseId);
    return await this.httpClient.get<Travel[]>(`${this.apiUrl}/byEnterprise/${enterpriseId}`).toPromise();
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // Return an observable with a user-facing error message.
    return throwError(
      'Something bad happened; please try again later.');
  }

  public getLiveTravels(travelId: string){
    try {
      let info = this.firestore.doc(`liveTravels/${travelId}`).valueChanges();
      return info;
    } catch (error) {
      console.error('error getting live travel info', error);
    }
  }
}
